/* WP11 · F7 / B-A8. Shared, lazy taxonomy; importing this file never fetches data. */
(function () {
  'use strict';
  if (window.tmTemas) return;

  var script = document.currentScript;
  var source = script && script.getAttribute('data-tm-temas-url');
  var pending;
  var data;
  var nextId = 0;
  var own = function (object, key) { return Object.prototype.hasOwnProperty.call(object || {}, key); };

  function load() {
    if (!pending) {
      pending = Promise.resolve().then(function () {
        if (!source) {
          var tag = document.querySelector('script[data-tm-temas-url]');
          source = tag && tag.getAttribute('data-tm-temas-url');
        }
        if (!source) throw new Error('Falta la URL de temáticas');
        return fetch(source);
      }).then(function (response) {
        if (!response.ok) throw new Error('No se pudieron cargar las temáticas');
        return response.json();
      }).then(function (json) {
        if (!json || !json.nombres || !json.disenos || !json.conteo || !Array.isArray(json.destacadas)) {
          throw new Error('Datos de temáticas incompletos');
        }
        data = json;
        return data;
      });
    }
    return pending;
  }

  function keyFor(url) {
    var value = String(url || '').trim();
    if (value.indexOf('//') === 0) value = 'https:' + value;
    value = value.split('?')[0].split('#')[0];
    var start = value.indexOf('/files/');
    return start < 0 ? '' : value.slice(start + 7);
  }

  function entryFor(url) {
    var key = keyFor(url);
    return data && own(data.disenos, key) ? data.disenos[key] : null;
  }

  function temasDe(url) {
    var entry = entryFor(url);
    return entry && Array.isArray(entry.t) ? entry.t.filter(function (slug) {
      return own(data.nombres, slug);
    }) : [];
  }

  function personajeDe(url) {
    var entry = entryFor(url);
    return entry && typeof entry.p === 'string' ? entry.p : '';
  }

  function element(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function styles() {
    if (document.getElementById('tm-temas-styles')) return;
    var style = element('style');
    style.id = 'tm-temas-styles';
    style.textContent = 
      '.tm-temas{min-width:0;margin-block:var(--tm-space-3,12px);color:var(--tm-ink,#171717);font:14px/1.45 var(--tm-font-body,Arial,sans-serif)}' +
      '.tm-temas [hidden],.tm-temas-cruce[hidden]{display:none!important}' +
      '.tm-temas__label{display:block;margin:0 0 var(--tm-space-2,8px);font-size:16px;font-weight:700}' +
      '.tm-temas__chips{display:grid;grid-auto-flow:column;grid-template-rows:repeat(2,minmax(44px,auto));grid-auto-columns:max-content;gap:var(--tm-space-2,8px);max-width:100%;overflow-x:auto;padding:4px 4px 8px;scroll-behavior:smooth;overscroll-behavior-x:contain;scroll-padding:4px;-webkit-overflow-scrolling:touch}' +
      '.tm-temas__chip,.tm-temas__clear{display:inline-flex;align-items:center;justify-content:center;min-height:44px;box-sizing:border-box;padding:8px 12px;border:1px solid var(--tm-border,#d6d0cb);border-radius:var(--tm-radius-control,10px);background:var(--tm-surface,#fff);color:var(--tm-ink,#171717);font:600 14px/1.3 var(--tm-font-body,Arial,sans-serif);cursor:pointer;white-space:nowrap}' +
      '.tm-temas__chip[aria-pressed="true"]{background:var(--tm-ink,#171717);border-color:var(--tm-ink,#171717);color:var(--tm-surface,#fff)}' +
      '.tm-temas__chip:focus-visible,.tm-temas__clear:focus-visible,.tm-temas-cruce__link:focus-visible{outline:3px solid var(--tm-focus,#185abc);outline-offset:2px}' +
      '.tm-temas__panel{display:grid;grid-template-columns:repeat(2,minmax(0,1fr));gap:var(--tm-space-2,8px);max-height:264px;overflow-y:auto;padding:var(--tm-space-2,8px);margin-top:8px;border:1px solid var(--tm-border,#d6d0cb);border-radius:var(--tm-radius-control,10px);background:var(--tm-surface-soft,#faf7f5)}' +
      '.tm-temas__panel .tm-temas__chip{white-space:normal;border-radius:var(--tm-radius-control,10px)}' +
      '.tm-temas__count{margin:8px 0 0;font-size:14px;line-height:1.45}' +
      '.tm-temas__clear{margin-top:4px;border-color:transparent;text-decoration:underline;text-underline-offset:3px}' +
      '.tm-temas-cruce{min-width:0;margin-block:var(--tm-space-3,12px);padding:var(--tm-space-3,12px);border:1px solid var(--tm-border,#d6d0cb);border-radius:var(--tm-radius-control,10px);background:var(--tm-surface-soft,#faf7f5);color:var(--tm-ink,#171717);font:14px/1.45 var(--tm-font-body,Arial,sans-serif)}' +
      '.tm-temas-cruce__title{margin:0 0 8px;font-size:16px;line-height:1.35;font-weight:700}' +
      '.tm-temas-cruce__list{display:grid;gap:8px;list-style:none;padding:0;margin:0}' +
      '.tm-temas-cruce__link{display:flex;flex-wrap:wrap;gap:4px 12px;align-items:center;justify-content:space-between;min-height:44px;box-sizing:border-box;padding:8px 12px;border:1px solid var(--tm-border,#d6d0cb);border-radius:var(--tm-radius-control,10px);background:var(--tm-surface,#fff);color:var(--tm-ink,#171717);font-size:14px;line-height:1.4;text-decoration:none}' +
      '.tm-temas-cruce__link:hover strong{text-decoration:underline}' +
      '@media(prefers-reduced-motion:reduce){.tm-temas__chips{scroll-behavior:auto}}';
    document.head.appendChild(style);
  }

  function mountFilters(container, options) {
    if (!container || !data) return null;
    options = options || {};
    var designs = options.designs || [];
    var counts = Object.create(null);
    var imageOf = options.imageOf || function (design) { return typeof design === 'string' ? design : design.image; };
    designs.forEach(function (design) {
      Array.from(new Set(temasDe(imageOf(design)))).forEach(function (slug) {
        counts[slug] = (counts[slug] || 0) + 1;
      });
    });
    var slugs = Object.keys(counts).filter(function (slug) { return counts[slug] >= 3; }).sort(function (a, b) {
      return counts[b] - counts[a] || data.nombres[a].localeCompare(data.nombres[b], 'es');
    });
    var active = own(data.nombres, options.initialTheme) ? options.initialTheme : '';
    var buttons = [];
    var wrapper = element('div', 'tm-temas');
    var label = element('p', 'tm-temas__label', 'Elegí por temática');
    label.id = 'tm-temas-label-' + (++nextId);
    var chips = element('div', 'tm-temas__chips');
    chips.setAttribute('role', 'group');
    chips.setAttribute('aria-labelledby', label.id);
    var panel = element('div', 'tm-temas__panel');
    panel.id = 'tm-temas-panel-' + nextId;
    panel.hidden = true;
    panel.setAttribute('role', 'group');
    panel.setAttribute('aria-label', 'Todas las temáticas de este producto');
    var count = element('p', 'tm-temas__count');
    count.setAttribute('aria-live', 'polite');
    count.setAttribute('aria-atomic', 'true');
    var clear = element('button', 'tm-temas__clear', 'Quitar temática');
    clear.type = 'button';

    function refresh() {
      buttons.forEach(function (button) {
        button.setAttribute('aria-pressed', String(button.dataset.tema === active));
      });
      var total = active ? (counts[active] || 0) : designs.length;
      count.textContent = (active ? data.nombres[active] : 'Todos') + ' · ' + total + (total === 1 ? ' diseño' : ' diseños') + ' para este producto';
      count.hidden = options.showCount === false;
      clear.hidden = !active;
    }

    function setTheme(slug) {
      active = own(data.nombres, slug) ? slug : '';
      refresh();
      if (typeof options.onChange === 'function') options.onChange(active);
    }

    function chip(slug) {
      var button = element('button', 'tm-temas__chip', (slug ? data.nombres[slug] : 'Todos') + ' (' + (slug ? counts[slug] : designs.length) + ')');
      button.type = 'button';
      button.dataset.tema = slug;
      button.addEventListener('click', function () { setTheme(slug); });
      buttons.push(button);
      return button;
    }

    chips.appendChild(chip(''));
    slugs.slice(0, 6).forEach(function (slug) { chips.appendChild(chip(slug)); });
    if (slugs.length > 6) {
      var more = element('button', 'tm-temas__chip', 'Ver todas');
      more.type = 'button';
      more.setAttribute('aria-expanded', 'false');
      more.setAttribute('aria-controls', panel.id);
      more.addEventListener('click', function () {
        panel.hidden = !panel.hidden;
        more.setAttribute('aria-expanded', String(!panel.hidden));
        more.textContent = panel.hidden ? 'Ver todas' : 'Ocultar temáticas';
      });
      chips.appendChild(more);
      slugs.forEach(function (slug) { panel.appendChild(chip(slug)); });
      panel.addEventListener('keydown', function (event) {
        if (event.key !== 'Escape') return;
        panel.hidden = true;
        more.setAttribute('aria-expanded', 'false');
        more.textContent = 'Ver todas';
        more.focus();
        event.stopPropagation();
      });
    }
    clear.addEventListener('click', function () {
      setTheme('');
      buttons[0].focus();
    });
    wrapper.appendChild(label);
    wrapper.appendChild(chips);
    wrapper.appendChild(panel);
    wrapper.appendChild(count);
    wrapper.appendChild(clear);
    refresh();
    styles();
    container.replaceChildren(wrapper);
    container.hidden = false;
    return {
      get theme() { return active; },
      filter: function (design) { return !active || temasDe(imageOf(design)).indexOf(active) !== -1; },
      setTheme: setTheme
    };
  }

  var productNames = {
    'figuras-de-cumpleanos': 'Figuras rígidas',
    'fondos-rigidos-circulares': 'Fondo redondo',
    'fondos-rigidos-cuadrados': 'Fondo cuadrado',
    'panel-romano': 'Panel romano',
    'kits-de-cumpleanos': 'Kit de cumpleaños',
    'marco-selfie': 'Marco selfie'
  };

  function productName(handle) {
    return productNames[handle] || (handle.indexOf('pasacalles-') === 0 ? 'Pasacalle' : '');
  }

  function permittedProduct(handle, theme) {
    if (own(productNames, handle) || handle === 'pasacalles-cumpleanos') return true;
    // Occasion-specific banners only belong to that occasion, never to children's themes.
    return (theme === 'bebe' && /^pasacalles-(babyshower|bienvenida)(-|$)/.test(handle)) ||
      (theme === 'quince' && /^pasacalles-quince/.test(handle)) ||
      (theme === 'egresados' && /^pasacalles-egresados/.test(handle)) ||
      (theme === 'romanticos' && /^pasacalles-romanticos/.test(handle));
  }

  function renderRecommendations(container, options) {
    if (!container) return;
    container.replaceChildren();
    container.hidden = true;
    if (!data || !options) return;
    var themes = temasDe(options.url);
    if (!themes.length) return;
    var theme = themes.indexOf(options.theme) !== -1 ? options.theme : themes[0];
    var counts = data.conteo[theme] || {};
    var handles = Object.keys(counts).filter(function (handle) {
      return handle !== options.handle && Number(counts[handle]) > 0 && permittedProduct(handle, theme);
    }).sort(function (a, b) {
      return counts[b] - counts[a] || productName(a).localeCompare(productName(b), 'es');
    }).slice(0, 3);
    if (!handles.length) return;
    styles();
    container.classList.add('tm-temas-cruce');
    var title = element('p', 'tm-temas-cruce__title', 'Completá tu fiesta de ' + data.nombres[theme]);
    var list = element('ul', 'tm-temas-cruce__list');
    handles.forEach(function (handle) {
      var item = element('li');
      var link = element('a', 'tm-temas-cruce__link');
      link.href = '/products/' + encodeURIComponent(handle) + '?tema=' + encodeURIComponent(theme);
      link.appendChild(element('strong', '', productName(handle)));
      link.appendChild(element('span', '', counts[handle] + (Number(counts[handle]) === 1 ? ' diseño de ' : ' diseños de ') + data.nombres[theme]));
      item.appendChild(link);
      list.appendChild(item);
    });
    container.appendChild(title);
    container.appendChild(list);
    container.hidden = false;
  }

  window.tmTemas = {
    load: load,
    temasDe: temasDe,
    personajeDe: personajeDe,
    mountFilters: mountFilters,
    renderRecommendations: renderRecommendations
  };
}());
